import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bepatient-text-holder',
  templateUrl: './text-holder.component.html',
  styleUrls: ['./text-holder.component.scss'],
  standalone: false
})
export class TextHolderComponent implements OnInit {
  @Input() text: string;
  @Input() subtitle: string;

  constructor() {}

  ngOnInit(): void {}
}
